import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import { getLab } from '../../Functions/Laboratorio/get_lab_by_cnpj';
import './ImageCarousel.css';

const ImageCarousel = ({ labCnpj }) => {
	const [images, setImages] = useState([]);
	const [loading, setLoading] = useState(true);
	const [carrosselAtivo, setCarrosselAtivo] = useState(false);

	useEffect(() => {
		if (labCnpj) {
			loadCarousel();
		} else {
			setLoading(false);
		}
	}, [labCnpj]);

	const loadCarousel = async () => {
		setLoading(true);
		try {
			const labData = await getLab(labCnpj);
			const ativo = !!(labData && labData.item && labData.item.carrosselAtivo);
			setCarrosselAtivo(ativo);

			if (ativo) {
				await fetchCarouselImages();
			}
		} catch (error) {
			setCarrosselAtivo(false);
		} finally {
			setLoading(false);
		}
	};

	const fetchCarouselImages = async () => {
		try {
			const params = new URLSearchParams({ lab_cnpj: labCnpj });
			const response = await fetch(
				`${process.env.REACT_APP_LABS_API}get_carousel_images.php?${params}`,
				{
					headers: {
						'Authorization': `Bearer ${sessionStorage.getItem('session_token')}`
					}
				}
			);

			const json = await response.json();

			if (json?.status === 200 && json.items && json.items.length > 0) {
				setImages(json.items);
			}
		} catch (error) {
		}
	};

	const getImageUrl = (imageId) => {
		return `${process.env.REACT_APP_LABS_API}get_carousel_image.php?image_id=${imageId}&type=arquivo`;
	};

	const handleImageClick = (image) => {
		if (image.link && image.link.trim() !== '') {
			window.open(image.link, '_blank', 'noopener,noreferrer');
		} else {
			window.open(getImageUrl(image.id), '_blank', 'noopener,noreferrer');
		}
	};

	if (loading || !carrosselAtivo || images.length === 0) {
		return null;
	}

	return (
		<div className="image-carousel-container">
			<Swiper
				modules={[Navigation, Pagination, Autoplay]}
				spaceBetween={0}
				slidesPerView={1}
				navigation
				pagination={{ clickable: true }}
				autoplay={{
					delay: 5000,
					disableOnInteraction: false,
					pauseOnMouseEnter: true
				}}
				loop={true}
				className="image-carousel">
				{images.map((image) => (
					<SwiperSlide key={image.id}>
						<div
							className="image-carousel__slide"
							onClick={() => handleImageClick(image)}>
							<img
								src={getImageUrl(image.id)}
								alt={image.nome}
								className="image-carousel__image"
							/>
						</div>
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
};

export default ImageCarousel;